















































































import {Component, Prop, Vue} from "vue-property-decorator";
// @ts-ignore
import Tools from '../../helpers/Tools';
// @ts-ignore
import store from '../../store';
import ErrorHandler from '../../helpers/ErrorHandler';
import ConferenceParticipant from '../../models/ConferenceParticipant';
import PlayerStatusAndRole from "../Player/PlayerStatusAndRole.vue";
import EventApi from "../../api/EventsApi";
import MessageHelper from "../../helpers/MessageHelper";
import GamePlayer from "../Player/GamePlayer.vue";
import type {GameRestrictions, Player, PlayerColor} from "../../../types";
import InviteBtn from "../Widgets/InviteBtn.vue";

const TYPE_VIDEO_DATA = 'videoData';

@Component({
    components: {InviteBtn, GamePlayer, PlayerStatusAndRole}
})

export default class GameConference extends Vue {
    @Prop({required: true}) private gameHash!: string;
    @Prop({required: true}) private isJoinModalVisible!: boolean;
    @Prop({required: true}) private settingsModalIsVisible!: boolean;
    @Prop({required: true}) private gameRestrictions!: GameRestrictions;

    private isCameraOn: boolean = false;
    private isAudioOn: boolean = false;
    private isMicrophoneOn: boolean = false;
    private isSupportedBrowser: boolean = true;
    private isConferenceConnected: boolean = false;
    private startConnectToConference: boolean = false;
    private seats: Array<number> = [1, 2, 3, 4, 5, 6];
    private seatsMap: {[key: number]: Player|null} = {
        1: null,
        2: null,
        3: null,
        4: null,
        5: null,
        6: null,
        7: null,
    };
    private conferenceParticipant: ConferenceParticipant = new ConferenceParticipant(this.gameHash);
    private joinModalIsVisible: boolean = false;
    private videoIsTransparent: boolean = false;
    private devicesList: Array<any> = [];
    private allowToggleDeviceStatus: boolean = true;

    mounted() {
        this.conferenceParticipant = new ConferenceParticipant(this.gameHash);
        if (!this.$conferenceManager.videoManager.checkBrowser()) {
            this.isSupportedBrowser = false;
        } else {
            this.bindEvents();
            if (this.conferenceIsAllowed) {
                Vue.nextTick(() => {
                    this.initConference();
                });
            } else {
                setTimeout(() => {this.joinModalIsVisible = true}, 3000);
            }

        }
    }

    /**
     * Разрешена инициализация конференции
     * @private
     */
    private get conferenceIsAllowed(): boolean
    {
        return store.getters.getConferenceIsAllowed;
    }

    /**
     * Current game state
     * @private
     */
    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    /**
     * ID текущего игрока
     * @private
     */
    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    /**
     * Список всех игроков
     * @private
     */
    private get players(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    /**
     * Текущий игрок
     * @private
     */
    private get player(): Player|null
    {
        const filtered = this.players.filter((player) => player.id === this.playerId);
        if (typeof filtered[0] !== 'undefined') {
            return filtered[0];
        }

        return null;
    }

    /**
     * Доступные цвета
     */
    private get availableColors(): Array<PlayerColor>
    {
        return this.gameState.availableColors;
    }

    /**
     * Кол-во занятых ситов
     * @private
     */
    private get takenSeatsCount(): number
    {
        let playerCount = 0;
        if (this.players && this.players.length) {
            playerCount = this.players.filter((player) => {
                return player.connectionStatus !== 'guest';
            }).length;
        }
        return playerCount;
    }

    /**
     * Статус подключения игрока (guest, active, pending)
     */
    private get playerConnectionStatus(): string
    {
        return store.getters.getPlayerConnectionStatus;
    }

    /**
     * Является гостем
     */
    private get isGuest(): boolean
    {
        return this.playerConnectionStatus === 'guest';
    }

    /**
     * Показывать модалку при запуске страницы
     */
    private get showSeatModalOnStart(): boolean
    {
        let dataFromStorage = JSON.parse((localStorage as any).getItem('playerConferenceData'));

        if (!dataFromStorage) {
            return true;
        }

        const gameId = dataFromStorage.gameId;
        if (gameId === this.gameHash) {
            return dataFromStorage.isGuest;
        }
        return true;
    }

    /**
     * Инициализация слушателей кастомных событий
     * @private
     */
    private bindEvents(): void
    {
        EventApi.addEventListener(EventApi.REMOTE_MEDIA_ADDED, this.processConnectVideos);
        EventApi.addEventListener(EventApi.REMOTE_MEDIA_REMOVED, this.processConnectVideos);

        EventApi.addEventListener(EventApi.SHOW_VIDEO, () => {
            this.videoIsTransparent = false;
        });
        EventApi.addEventListener(EventApi.HIDE_VIDEO, () => {
            this.videoIsTransparent = true;
        });
        EventApi.addEventListener(EventApi.DEVICES_READY, this.updateDevicesList);
        EventApi.addEventListener('localVideoEndpointAdded', this.sendPlayerConferenceStateMessage);
        EventApi.addEventListener('endpointAdded', this.changePlayersData);

        EventApi.addEventListener(EventApi.TABLE_CAMERA, () => {
            this.changeCameraStatus(!this.isCameraOn);
        });
        EventApi.addEventListener(EventApi.TABLE_MICROPHONE, () => {
            this.changeMicrophoneStatus(!this.isMicrophoneOn);
        });
    }

    /**
     * Инициализация конференции
     * @private
     */
    private initConference(): void
    {
        EventApi.addEventListener(EventApi.VIDEO_CONFERENCE_READY, () => {
            this.startConnectToConference = true;
            this.connectToVideoConf();
        });

        EventApi.addEventListener(EventApi.DEVICES_ACCESS_GRANTED, () => {
            this.$conferenceManager.devicesManager.initDevices().then((result) => {
                if (this.showSeatModalOnStart) {
                    this.isCameraOn = true;
                    this.isMicrophoneOn = true;

                    store.dispatch('setCameraStatus', this.isCameraOn);
                    store.dispatch('setMicrophoneStatus', this.isMicrophoneOn);

                    this.sendPlayerConferenceStateMessage();

                    this.joinModalIsVisible = true;
                }
            });
        });
    }

    /**
     * Закрыть модалку подключения к конференции
     * @param saveSettings
     * @private
     */
    private closeJoinModal(saveSettings: boolean = false): void
    {
        this.joinModalIsVisible = false;
        this.$emit('close-join-modal', saveSettings);
    }

    /**
     * Закрыть модалку настроек игры
     * @private
     */
    private closeSettingsModal(saveSettings = false): void
    {
        this.$emit('close-settings-modal', saveSettings);
    }

    /**
     * Открыть модалку Join
     * @private
     */
    private openJoinModal(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('open-join-modal');
    }

    private savePlayerSettings(data: {
        camera: boolean,
        microphone: boolean,
        color: string
    }): void
    {
        this.isCameraOn = data.camera;
        this.isMicrophoneOn = data.microphone;

        this.$conferenceManager.devicesManager.stopLocalMedia();

        Tools.runTimer('changePlayerColor', () => {
            this.setColor(data.color).then(() => {
                this.conferenceParticipant.setCameraStatus(this.isCameraOn);
                this.applyCameraStatus();

                this.conferenceParticipant.setMicrophoneStatus(this.isMicrophoneOn);
                this.applyMicrophoneStatus();

                if (this.isGuest) {
                    this.conferenceParticipant.setGuestStatus(!this.isGuest);
                } else {
                    this.conferenceParticipant.setGuestStatus(this.isGuest);
                }
                EventApi.triggerEvent(EventApi.LOCAL_TRACK_PUBLISHED);
            });
            // MessageHelper.sendMessage('getGameField', {}); //дополнительно запрашиваем игровой стол при инициализации сита
        });

        store.dispatch('setCameraStatus', this.isCameraOn);
        store.dispatch('setMicrophoneStatus', this.isMicrophoneOn);
    }

    /**
     * Сменить устройство
     * @param data
     * @private
     */
    private changeDevice(data: any): void
    {
        const deviceType = data.type;
        const deviceId = data.id;

        switch (deviceType) {
            case 'microphone':
                this.$conferenceManager.devicesManager.changeMicrophone(deviceId.toString());
                break;

            case 'camera':
                this.$conferenceManager.devicesManager.changeCamera(deviceId.toString());
                break;
        }

        this.updateDevicesList();
    }

    /**
     * Включить\выключить камеру напрямую
     * @param status
     */
    private setCameraStatus(status: boolean): void
    {
        this.isCameraOn = status;
        this.$conferenceManager.devicesManager.stopLocalMedia();
        this.conferenceParticipant.setCameraStatus(this.isCameraOn);
        this.applyCameraStatus();
        store.dispatch('setCameraStatus', status);
    }

    /**
     * Включить\выключить камеру
     */
    private changeCameraStatus(status: boolean): void
    {
        if (!this.allowToggleDeviceStatus) {
            return;
        }
        this.allowToggleDeviceStatus = false;

        if (typeof status !== 'undefined') {
            this.isCameraOn = status;
        } else {
            this.isCameraOn = !this.isCameraOn;
        }
        store.dispatch('setCameraStatus', this.isCameraOn);

        this.applyCameraStatus().then(() => {
            this.$conferenceManager.devicesManager.setCallSettings().then(() => {
                this.conferenceParticipant.setCameraStatus(this.isCameraOn);
                EventApi.triggerEvent(EventApi.CAMERA_STATUS_CHANGED, this.isCameraOn);
                this.allowToggleDeviceStatus = true;
                // MessageHelper.sendMessage('getGameField', {});
            });
        });
    }

    /**
     * Включить\выключить звук напрямую
     * @param status
     */
    private setAudioStatus(status: boolean): void
    {
        this.isAudioOn = status;
        this.applyAudioStatus();
    }

    /**
     * Включить\выключить звук
     */
    private changeAudioStatus(): void
    {
        this.isAudioOn = !this.isAudioOn;
        this.applyAudioStatus();
    }

    /**
     * Применить настройки аудио
     */
    private applyAudioStatus(): void
    {
        this.$conferenceManager.videoManager.audioToggle(this.isAudioOn);
        this.sendPlayerConferenceStateMessage();
    }

    /**
     * Применить настройки камеры
     */
    private async applyCameraStatus(): Promise<void>
    {
        await this.$conferenceManager.videoManager.cameraToggle(this.isCameraOn).then(() => {
            this.sendPlayerConferenceStateMessage();
        });
    }

    /**
     * Статус камеры
     */
    private getCameraStatus(): boolean
    {
        return this.isCameraOn;
    }

    /**
     * Включить\выключить микрофон напрямую
     * @param status
     */
    private setMicrophoneStatus(status: boolean): void {
        this.isMicrophoneOn = status;
        this.$conferenceManager.devicesManager.stopLocalMedia();
        this.conferenceParticipant.setMicrophoneStatus(this.isMicrophoneOn);
        this.applyMicrophoneStatus();
        store.dispatch('setMicrophoneStatus', status);
    }

    /**
     * Включить\выключить микрофон
     */
    private changeMicrophoneStatus(status: boolean): void
    {
        if (!this.allowToggleDeviceStatus) {
            return;
        }
        this.allowToggleDeviceStatus = false;

        if (typeof status !== 'undefined') {
            this.isMicrophoneOn = status;
        } else {
            this.isMicrophoneOn = !this.isMicrophoneOn;
        }

        store.dispatch('setMicrophoneStatus', this.isMicrophoneOn);

        this.applyMicrophoneStatus().then(() => {
            this.$conferenceManager.devicesManager.setCallSettings().then(() => {
                this.conferenceParticipant.setMicrophoneStatus(this.isMicrophoneOn);
                EventApi.triggerEvent(EventApi.MICROPHONE_STATUS_CHANGED, this.isMicrophoneOn);
                this.allowToggleDeviceStatus = true;
                // MessageHelper.sendMessage('getGameField', {});
            });
        });
    }

    /**
     * Применить настройки микрофона
     */
    private async applyMicrophoneStatus(): Promise<void>
    {
        await this.$conferenceManager.videoManager.microphoneToggle(this.isMicrophoneOn);
        this.sendPlayerConferenceStateMessage();
    }

    /**
     * Статус микрофона
     */
    private getMicrophoneStatus(): boolean
    {
        return this.isMicrophoneOn;
    }

    /**
     * Статус аудио
     */
    private getAudioStatus(): boolean
    {
        return this.isAudioOn;
    }

    /**
     * Подключиться к видеоконференции
     */
    private connectToVideoConf(): void
    {
        ErrorHandler.info('Гость, отключаем видео и микрофон');
        this.turnOffVideoAndMic();
        this.$conferenceManager.videoManager.connectToConf(this.gameHash, this.playerId);
        if (this.isGuest) {
            EventApi.addEventListener('callConnected', () => {
                setTimeout(() => {
                    this.isConferenceConnected = true;
                    if (this.isNeedToAutoTakeSeat() && this.availableColors.length > 0) {
                        this.isMicrophoneOn = this.conferenceParticipant.getMicrophoneStatus();
                        this.isCameraOn = this.conferenceParticipant.getCameraStatus();

                        store.dispatch('setCameraStatus', this.isCameraOn);
                        store.dispatch('setMicrophoneStatus', this.isMicrophoneOn);

                        this.setColor('first').then(() => {
                            this.applyCameraStatus();
                            this.applyMicrophoneStatus();
                            MessageHelper.playerConnected();
                            EventApi.triggerEvent(EventApi.LOCAL_TRACK_PUBLISHED);
                        });
                    }
                }, 1000);
            });
        }
    }

    /**
     * прикрепить видео к игрокам
     */
    private connectVideosToPlayers(): void
    {
        ErrorHandler.info('Connecting videos to players..');

        const playersHolders = this.$refs.players as Array<GamePlayer>;
        let videoHolders: Array<HTMLElement> = [];
        [...playersHolders].forEach(holder => {
            if (holder.getVideoHolder() instanceof HTMLElement) {
                videoHolders.push(holder.getVideoHolder() as HTMLElement);
            }
        });
        this.$conferenceManager.videoManager.render(videoHolders);
    }

    /**
     * Изменить данные игроков
     */
    public changePlayersData(): void
    {
        Vue.nextTick(() => {
            if (this.players && this.player && this.conferenceIsAllowed) {
                Tools.runTimer('connectVideosToPlayers', () => {this.connectVideosToPlayers()}, 300);
            }
        });
    }

    /**
     * Изменить цвет
     * @param code
     */
    changeColor(code: string)
    {
        this.$conferenceManager.devicesManager.stopLocalMedia();

        Tools.runTimer('changePlayerColor', () => {
            this.setColor(code).then(() => {
                if (this.isGuest) {
                    this.conferenceParticipant.setCameraStatus(this.isCameraOn);
                    this.applyCameraStatus();

                    this.conferenceParticipant.setMicrophoneStatus(this.isMicrophoneOn);
                    this.applyMicrophoneStatus();
                    this.conferenceParticipant.setGuestStatus(!this.isGuest);
                }
            });
            // MessageHelper.sendMessage('getGameField', {}); //дополнительно запрашиваем игровой стол при инициализации сита
        });

        setTimeout(() => {
            const tableHandInstance = window.PixiScene;

            if (tableHandInstance) {
                tableHandInstance.updatePlayerColor();
            }
        }, 1000);
    }

    /**
     * Выйти из сита и стать гостем
     */
    private becomeGuest(): void
    {
        this.turnOffVideoAndMic();
        this.conferenceParticipant.setGuestStatus(true);

        MessageHelper.sendMessage('becomeGuest', {});
    }

    /**
     * установить цвет
     */
    private async setColor(code: string)
    {
        await this.$conferenceManager.devicesManager.setCallSettings().then(() => {
            const data = {
                playerId: this.player ? this.player.id : '',
                color: code
            };

            MessageHelper.sendMessage('changePlayerColor', data);
        });
    }

    /**
     * Выключить звук и видео
     */
    private turnOffVideoAndMic(): void
    {
        this.isCameraOn = false;
        this.$conferenceManager.videoManager.cameraToggle(this.isCameraOn);

        this.isMicrophoneOn = false;
        this.$conferenceManager.videoManager.microphoneToggle(this.isMicrophoneOn);

        store.dispatch('setCameraStatus', this.isCameraOn);

        this.sendPlayerConferenceStateMessage();
    }

    /**
     * Обновить карту ситов
     */
    public updateSeatsMap(): void
    {
        this.seatsMap = {
            1: null,
            2: null,
            3: null,
            4: null,
            5: null,
            6: null
        };

        let i = 1;
        this.players.forEach((player) => {
            if (player.connectionStatus !== 'guest') {
                if (player.id === this.player?.id) {
                    this.seatsMap[0] = player;
                    return;
                }

                this.seatsMap[i] = player;
                i++;
            }
        });
    }

    /**
     * Необходимо автоматически занять сит
     * @returns {boolean}
     */
    private isNeedToAutoTakeSeat(): boolean
    {
        const params = new URLSearchParams(window.location.search);
        return params.has('autoTakeSeat') || !this.conferenceParticipant.getGuestStatus();
    }

    /**
     * Обновить список устройств
     */
    private updateDevicesList(): void
    {
        this.devicesList = [];

        this.$conferenceManager.devicesManager.getCamerasList().forEach((device: any) => {
            if (typeof device !== 'undefined' && !!device.id) {
                device.type = 'camera';
                device.isActive = device.id === this.$conferenceManager.devicesManager.getCameraId();
                this.devicesList.push(device);
            }
        });
        this.$conferenceManager.devicesManager.getMicrophonesList().forEach((device: any) => {
            if (typeof device !== 'undefined' && !!device.id) {
                device.type = 'microphone';
                device.isActive = device.id === this.$conferenceManager.devicesManager.getMicId();
                this.devicesList.push(device);
            }
        });
    }

    /**
     * Отправить состояние устройств игрока
     */
    private sendPlayerConferenceStateMessage(): void
    {
        const data = {
            endpointId: this.playerId,
            cameraStatus: this.getCameraStatus(),
            microphoneStatus: this.getMicrophoneStatus(),
            audioStatus: this.getAudioStatus(),
        };

        MessageHelper.sendMessage(TYPE_VIDEO_DATA, data);
    }

    /**
     * Обработка прикрепления видео к игрокам
     */
    private processConnectVideos(): void
    {
        Tools.runTimer('connectVideosToPlayers', () => {this.connectVideosToPlayers()}, 300);
    }
}
